module.exports = __webpack_public_path__ + "img/fa-card-avatar-placeholder.6cdf5485.svg";